import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './SubscriptionBanner.css';

const SubscriptionBanner = ({ userId = 1, onNavigateToTariffs }) => {
  const [state, setState] = useState({
    subscription: null,
    loading: true,
    error: null
  });

  useEffect(() => {
    loadSubscription();
  }, [userId]);

  const loadSubscription = async () => {
    setState({ subscription: null, loading: true, error: null });
    
    try {
      const response = await api.get(`/v1/billing/subscription?user_id=${userId}`);
      setState({ subscription: response.data, loading: false, error: null });
    } catch (error) {
      setState({ 
        subscription: null, 
        loading: false, 
        error: error.response?.status === 404 ? 'no_subscription' : 'error' 
      });
    }
  };

  // Не показываем баннер во время загрузки
  if (state.loading) {
    return null;
  }
  
  // Если нет подписки, показываем баннер с предложением пробного периода
  if (state.error || !state.subscription) {
    return (
      <div className="subscription-banner info">
        <div className="banner-content">
          <div className="banner-icon">🎁</div>
          <div className="banner-text">
            <div className="banner-title">Активируйте пробный период на 14 дней</div>
            <div className="banner-subtitle">Бесплатный доступ ко всем возможностям приложения</div>
          </div>
          <button className="banner-button" onClick={() => window.location.href = '#billing'}>
            Начать пробный период
          </button>
        </div>
      </div>
    );
  }
  
  const { subscription } = state;

  const isTrial = subscription.is_trial || subscription.status === 'trial';
  const daysLeft = subscription.days_left;
  
  // Показываем баннер только для пробных подписок
  if (!isTrial) {
    return null;
  }

  // Цвета и иконки для статусов пробного периода
  const getStatusConfig = () => {
    if (daysLeft <= 1) {
      return {
        color: 'danger',
        icon: '⚠️',
        title: `Пробный период заканчивается ${daysLeft === 0 ? 'СЕГОДНЯ' : 'ЗАВТРА'}!`,
        subtitle: 'Выберите тариф, чтобы не потерять доступ к креативам',
        showButton: true
      };
    } else if (daysLeft <= 3) {
      return {
        color: 'warning',
        icon: '⏰',
        title: `Пробный период заканчивается через ${daysLeft} дня`,
        subtitle: 'Успейте выбрать подходящий тариф без потери данных',
        showButton: true
      };
    } else {
      return {
        color: 'success',
        icon: '🎁',
        title: 'Пробный период активен',
        subtitle: `Осталось ${daysLeft} ${daysLeft === 1 ? 'день' : daysLeft < 5 ? 'дня' : 'дней'} бесплатного доступа`,
        showButton: false
      };
    }
  };

  const config = getStatusConfig();

  const handleUpgrade = () => {
    if (onNavigateToTariffs) {
      onNavigateToTariffs();
    }
    // Всегда обновляем hash, чтобы можно было открыть раздел напрямую
    if (window.location.hash !== '#billing-tariffs') {
      window.location.hash = '#billing-tariffs';
    } else {
      // Если hash уже установлен, вручную инициируем событие для совместимости
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  };

  return (
    <div className={`subscription-banner ${config.color}`}>
      <div className="banner-content">
        <div className="banner-icon">{config.icon}</div>
        <div className="banner-text">
          <div className="banner-title">{config.title}</div>
          <div className="banner-subtitle">{config.subtitle}</div>
        </div>
        {config.showButton && (
          <button className="banner-button" onClick={handleUpgrade}>
            Выбрать тариф
          </button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionBanner;

